import { List, Map, fromJS, isList, isMap } from 'immutable';
import { put, takeLatest } from 'redux-saga/effects';
import Cookies from 'universal-cookie';
import PicabooConstants from '../common/PicabooConstants';
import { getToken } from '../utils/apiServices';
import { hexToDecimal } from '../utils/color';
import * as BackgroundsActions from './backgrounds';
import {
  SET_BACKGROUND_COLOR_UNDOABLE,
  SET_BACKGROUND_IMAGE,
} from './backgrounds';
import { updateAccountPreferenceSaga } from './changesets';

export const GET_USER_DETAILS = 'user/GET_USER_DETAILS';
export const SET_USER_DETAILS = 'user/SET_USER_DETAILS';
export const USER_LOGGED_OUT = 'user/USER_LOGGED_OUT';
export const UPDATE_USER_PREFERENCE = 'user/UPDATE_USER_PREFERENCE';
export const SHOW_INITIAL_LOGIN_MODAL = 'user/SHOW_INITIAL_LOGIN_MODAL';

const DISABLE_DESIGNER = 'user/DISABLE_DESIGNER';
const NEW_COLOR_USED = 'user/NEW_COLOR_USED';

export function disableDesigner() {
  return {
    type: DISABLE_DESIGNER,
  };
}
/**
 *  reducers
 */
var initialState = fromJS({
  isInitialLoading: true,
  isInitialLoginModalShown: false,
  isGuest: true,
  firstName: '',
  lastName: '',
  email: '',
  token: undefined,
  blurbID: undefined,
  accountID: undefined,
  loginError: {},
  preferences: Map(),
  userLoggedOut: false,
  impersonating: false,
});

const user = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_DETAILS: {
      const update = {
        isInitialLoading: false,
        isGuest: !action.user.loggedIn || !action.user.blurbID,
        blurbID: action.user.blurbID,
        accountID: action.user.accountID,
        firstName: action.user.firstName,
        lastName: action.user.lastName,
        email: action.user.email,
        token: action.user.token,
        specialOps: action.user.specialOps,
        logoPath: action.user.logoPath,
        preferences: action.user.preferences,
        impersonating: action.user.impersonating,
        blurbUsername: action.user.blurbUsername,
      };
      return state.mergeDeep(update);
    }
    case SHOW_INITIAL_LOGIN_MODAL: {
      return state.merge({ isInitialLoginModalShown: true });
    }
    case NEW_COLOR_USED:
    case SET_BACKGROUND_COLOR_UNDOABLE:
    case 'selection/EYEDROPPER_COLOR': // importing EYEDROPPER_COLOR from selection breaks everything... some circle reference or something
      const ignoreColors = [0, 16777215]; // black and white
      if (action.color !== undefined && !ignoreColors.includes(action.color)) {
        let color =
          !isNaN(parseFloat(action.color)) && isFinite(action.color)
            ? action.color
            : String(hexToDecimal(action.color));
        return state.updateIn(
          ['preferences', 'recentlyUsedColors'],
          [],
          (list) => {
            list = list.filter((entry) => {
              if (entry) {
                return entry.color !== color;
              }
              return false;
            });

            list.unshift({ color });

            if (list.length > 14) {
              list = list.slice(0, 14);
            }

            return list;
          },
        );
      }
      return state;
    case SET_BACKGROUND_IMAGE:
      return state.updateIn(
        ['preferences', 'recentlyUsedBackgrounds', 'background'],
        List(),
        (list) => list.push(fromJS({ id: action.imageID })),
      );

    case UPDATE_USER_PREFERENCE:
      return state.setIn(['preferences', action.preferenceName], action.value);

    case USER_LOGGED_OUT:
      return initialState.merge({ userLoggedOut: true });
    case DISABLE_DESIGNER:
      return state.set('specialOps', 0);

    default:
      return state;
  }
};

/**
 *  actions
 */

export function setUserDetails(user) {
  return {
    type: SET_USER_DETAILS,
    user,
  };
}

export function getUserDetails() {
  return {
    type: GET_USER_DETAILS,
  };
}

export function newColorUsed(color) {
  return {
    type: NEW_COLOR_USED,
    color,
    preferenceName: PicabooConstants.PREFERENCE_NAME.RECENTLY_USED_COLORS,
  };
}

export function updateUserPreference(preferenceName, value) {
  return {
    type: UPDATE_USER_PREFERENCE,
    preferenceName,
    value,
  };
}

export function showInitialLoginModal() {
  return { type: SHOW_INITIAL_LOGIN_MODAL };
}

/**
 * Sagas
 */

function getUserDetailsFromResult(result) {
  result.preferences = result.preferences || {};
  result.preferences[
    PicabooConstants.PREFERENCE_NAME.KEEP_CLOSED_GETTING_STARTED
  ] =
    result.preferences[
      PicabooConstants.PREFERENCE_NAME.KEEP_CLOSED_GETTING_STARTED
    ];
  return result;
}

function* getUserDetailsSaga() {
  if (global.isRenderer) {
    return;
  }

  try {
    let result = yield getToken();
    result = getUserDetailsFromResult(result);
    yield put(setUserDetails(result));
  } catch (error) {
    let token = new Cookies().get('web-editor-token');
    if (token) {
      // This most likely means that the token is expired. Need to remove the cookie and reload the page.
      new Cookies().remove('web-editor-token');
      window.location = '/';
    } else {
      console.error(error);
    }
  }
}

function* setupSagas() {
  yield takeLatest(GET_USER_DETAILS, getUserDetailsSaga);

  yield takeLatest(
    BackgroundsActions.SET_BACKGROUND_COLOR,
    updateAccountPreferenceSaga,
  );
  yield takeLatest(
    BackgroundsActions.SET_BACKGROUND_COLOR_UNDOABLE,
    updateAccountPreferenceSaga,
  );
  yield takeLatest(NEW_COLOR_USED, updateAccountPreferenceSaga);
  // yield takeLatest(BackgroundsActions.SET_BACKGROUND_IMAGE, updateAccountPreferenceSaga);
}

export function isInitialLoadingSelector(state) {
  return state.user.get('isInitialLoading');
}

export function isInitialLoginModalShownSelector(state) {
  return state.user.get('isInitialLoginModalShown');
}

/** ***********************************************************************
 *  Main Export
 *  *********************************************************************** */
export default {
  reducer: user,
  saga: setupSagas,
};
